import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Про нас',
    href: '#about'
  }, {
    name: 'Послуги',
    href: '#services'
  }, {
    name: 'Портфоліо',
    href: '#portfolio'
  }, {
    name: 'Відгуки',
    href: '#testimonials'
  }];
  return <>
      <motion.nav initial={{
      y: -100
    }} animate={{
      y: 0
    }} transition={{
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1]
    }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-background/80 backdrop-blur-md py-4 border-b border-white/5' : 'bg-transparent py-6'}`} data-id="element-100">
        <div className="container mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-101">
          {/* Logo */}
          <a href="#" className="text-2xl font-serif font-medium tracking-widest uppercase text-ivory flex items-center gap-2" data-id="element-102">
            <span className="text-gold" data-id="element-103">A</span>ura
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-12" data-id="element-104">
            <div className="flex gap-8" data-id="element-105">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-sans uppercase tracking-widest text-ivory/70 hover:text-gold transition-colors duration-300 relative group" data-id="element-106">
                  {link.name}
                  <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-gold transition-all duration-300 group-hover:w-full" data-id="element-107"></span>
                </a>)}
            </div>

            <div className="flex items-center gap-4 border-l border-white/10 pl-8" data-id="element-108">
              <div className="flex gap-2 text-xs font-sans uppercase tracking-widest" data-id="element-109">
                <button className="text-gold" data-id="element-110">UA</button>
                <span className="text-white/20" data-id="element-111">|</span>
                <button className="text-ivory/50 hover:text-ivory transition-colors" data-id="element-112">
                  RU
                </button>
              </div>
              <a href="#contact" className="px-6 py-2 border border-gold/30 text-gold text-sm uppercase tracking-widest hover:bg-gold hover:text-background transition-all duration-300" data-id="element-113">
                Зв'язатися
              </a>
            </div>
          </div>

          {/* Mobile Toggle */}
          <button className="md:hidden text-ivory" onClick={() => setIsMobileMenuOpen(true)} data-id="element-114">
            <Menu size={24} data-id="element-115" />
          </button>
        </div>
      </motion.nav>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-116">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        clipPath: 'circle(0% at 100% 0)'
      }} animate={{
        opacity: 1,
        clipPath: 'circle(150% at 100% 0)'
      }} exit={{
        opacity: 0,
        clipPath: 'circle(0% at 100% 0)'
      }} transition={{
        duration: 0.5,
        ease: [0.16, 1, 0.3, 1]
      }} className="fixed inset-0 z-[60] bg-background flex flex-col justify-center items-center" data-id="element-117">
            <button className="absolute top-6 right-6 text-ivory p-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-118">
              <X size={32} data-id="element-119" />
            </button>

            <div className="flex flex-col items-center gap-8 text-center" data-id="element-120">
              {navLinks.map((link, i) => <motion.a key={link.name} href={link.href} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1 * i + 0.2
          }} onClick={() => setIsMobileMenuOpen(false)} className="text-4xl font-serif text-ivory hover:text-gold transition-colors" data-id="element-121">
                  {link.name}
                </motion.a>)}

              <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.6
          }} className="mt-8 flex flex-col items-center gap-6" data-id="element-122">
                <div className="flex gap-4 text-lg font-sans uppercase tracking-widest" data-id="element-123">
                  <button className="text-gold" data-id="element-124">UA</button>
                  <span className="text-white/20" data-id="element-125">|</span>
                  <button className="text-ivory/50" data-id="element-126">RU</button>
                </div>
                <a href="#contact" onClick={() => setIsMobileMenuOpen(false)} className="px-8 py-3 bg-gold text-background text-sm uppercase tracking-widest" data-id="element-127">
                  Зв'язатися
                </a>
              </motion.div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}